storefrontApp.service('accountService', ['$http', function ($http) {
    return {
        getCustomerInfo: function () {
            return $http.get(
                "storefrontapi/account?t=" + new Date().getTime()
            );
        },

        getFormats: function () {
            return $http.get(
                "storefrontapi/account/formats"
            );
        },

        getUserEmailSubscriptions: function (userId) {
            return $http.get(
                'emailcampaign/getusersubscriptions?userId=' + userId
            );
        },

        updateUserEmailSubscriptions: function (userId, campaignIds, optIns) {
            return $http.post(
                'emailcampaign/updateuseremailsubscriptions',
                { userId: userId, campaignIds: campaignIds, optIns: optIns }
            );
        },

        changePassword: function (password) {
            return $http.post(
                "storefrontapi/account/update-password",
                password
            );
        },

        updatePassword: function (changePasswordData) {
            return $http.post(
                'storefrontapi/account/password',
                changePasswordData
            );
        },

        updateUserProfile: function (profileUpdate) {
            return $http.post(
                'account/updateprofile',
                profileUpdate
            );
        },

        addNewAddress: function (addressToAdd) {
            return $http.post(
                'account/addcustomeraddress',
                { AddressToUpdate: addressToAdd.addressItem, isDefault: addressToAdd.isDefault }
            );
        },

        updateAddress: function (addressToUpdate) {
            return $http.post(
                'account/updatecustomeraddress',
                { AddressToUpdate: addressToUpdate.addressItem, isDefault: addressToUpdate.isDefault }
            );
        },

        deleteAddress: function (addressKey) {
            return $http.post(
                'account/deletecustomeraddress',
                { index: addressKey }
            );
        },

        getGiftcardsByUserId: function () {
            return $http.get('storefrontapi/account/getallgiftcards');
        },
        redeemGiftCard: function (activationCode) {
            return $http.post('storefrontapi/account/redeemgiftcard?uniqueGiftCardId=' + activationCode);
        },

        getCustomerMembershipDetails: function (userId) {
            return $http.get('storefrontapi/club/membershipinfo?userId=' + userId);
        },

        getMembershipGoodies: function (userId) {
            return $http.get('storefrontapi/club/goodies?userId=' + userId);
        },

        addMachine: function (machine, isDefault) {
            return $http.post('storefrontapi/account/machines/add',
                { customerMachine: machine, isDefault: isDefault }
            );
        },

        updateMachine: function (machine, isDefault) {
            return $http.post('storefrontapi/account/machines/update',
                { customerMachine: machine, isDefault: isDefault }
            );
        },

        deleteMachine: function (machine, isDefault) {
            return $http.post('storefrontapi/account/machines/delete',
                { customerMachine: machine, isDefault: isDefault }
            );
        },
        updateCustomerMembershipDetails: function (membership) {
            return $http.post('storefrontapi/club/membershipinfo', membership);
        },
        validateAddress: function (addressResult) {
            return $http.post('storefrontapi/shipping/validateaddress', addressResult);
        },
        resendEmailVerificationLink: function (userId) {
            return $http.post('account/resendverifyaccountemail?userId=' + userId)
        }
    }
}]);
